export const LogoMark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="lg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#C084FC" />
        <stop offset="1" stopColor="#7C3AED" />
      </linearGradient>
    </defs>
    <path d="M32 6 56 20v24L32 58 8 44V20Z" fill="none" stroke="url(#lg)" strokeWidth="4" strokeLinejoin="round" />
    <circle cx="32" cy="27" r="7" fill="url(#lg)" />
    <path d="M28 32h8l3 14H25Z" fill="url(#lg)" />
    <rect x="31" y="14" width="2" height="6" fill="#E9D5FF" />
  </svg>
);

export const Logo = () => (
  <a href="/" data-testid="brand-logo" className="flex items-center gap-3 group">
    <LogoMark className="w-9 h-9 transition-transform duration-500 group-hover:rotate-[30deg]" />
    <span className="hidden sm:inline font-display text-sm tracking-[0.2em] uppercase text-white">
      Rahsia<span className="text-violet-300">/</span>Trading
    </span>
  </a>
);
